<template>
    <div>
        <convenio-documentos :convenio="convenio"
        :dataServicos="dataServicos">
        </convenio-documentos>
        <b-card no-body>
            <b-card-header>
                <span class="h5"> Prestação de Contas Mensal </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-tabela
                        idTabela="tblPrestacaoContasMensal"
                        :itens="listaPrestacoes"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false">
                        <template slot="botoes">
                            <b-button-group
                                class="float-right"
                                v-if="permiteCadastrarPrestacaoMensal">
                                <Cad-Prestacao-Mensal
                                    :idConvenio="convenio.idConvenio"
                                    :idSituacaoConvenio="convenio.idSituacaoConvenio"
                                    :dataServicos="dataServicos"
                                    class="mr-2"
                                    @atualizarLista="carregarLista()">
                                </Cad-Prestacao-Mensal>
                            </b-button-group>
                        </template>

                        <template slot="acoes" slot-scope="data">
                            <span
                                class="text-danger float-left mr-1"
                                v-if="permiteExcluirJustificarPrestacaoMensal">
                                <i
                                    class="fa fa-exclamation-circle fa-lg icon-button"
                                    title="Justificativa"
                                    v-if="data.codSituacao == 2 && convenio.idSituacaoConvenio != 9"
                                    @click.stop="mostrarJustificativa(data.justificativa)"
                                ></i>
                            </span>
                            <span
                                class="text-danger float-left mr-1"
                                v-if="permiteExcluirJustificarPrestacaoMensal">
                                <i
                                    class="fa fa-trash fa-lg icon-button"
                                    title="Excluir"
                                    v-if="data.codSituacao == 0 && convenio.idSituacaoConvenio != 9 && !data.passouCompetencia"
                                    @click.stop="excluir(data.idPrestacaoContasMensal)"
                                ></i>
                            </span>
                            <span
                                class="text-success float-left mr-1"
                                v-if="permiteEnviarPrestacaoParaAnalise">
                                <i
                                    class="fa fa-upload fa-lg icon-button"
                                    title="Enviar para análise"
                                    v-if="(data.codSituacao == 0 || data.codSituacao == null) 
                                    && convenio.idSituacaoConvenio != 9 && 
                                    (!data.passouCompetencia || (data.passouCompetencia && !data.lancamentosBloqueados))"
                                    @click.stop="confirmarEnviar(data.idPrestacaoContasMensal)"
                                ></i>
                            </span>
                            <span
                                class="text-primary float-left mr-1"
                                v-if="temAcessoPrestacaoFinal">
                                <prestacao-final
                                    class="mr-2"
                                    :idPrestacaoMensal="data.idPrestacaoContasMensal"
                                    :convenio="convenio"
                                    v-if="convenio.idSituacaoConvenio != 9"
                                    :dataServicos="dataServicos"
                                    :permiteCadastrarPrestacaoFinal="permiteCadastrarPrestacaoFinal"
                                    :permiteExcluirPrestacaoFinal="permiteExcluirPrestacaoFinal"
                                    :permiteAtualizarPrestacaoFinal="permiteAtualizarPrestacaoFinal"
                                    :permiteAcessarDocumentos="permiteAcessarDocumentos"
                                    :permiteExcluirJustificarPrestacaoMensal="permiteExcluirJustificarPrestacaoMensal"
                                    :permiteCadastrarDocumentos="permiteCadastrarDocumentos"
                                    :permiteExcluirDocumentos="permiteExcluirDocumentos"
                                    @atualizarLista="atualizarLista()">
                                </prestacao-final>
                            </span>
                        </template>

                        <template slot="dtCompetencia" slot-scope="data">
                            <p class="text-left m-0">
                                {{ data.dtCompetencia ? $moment(data.dtCompetencia).format('MM/YYYY') : '' }}
                            </p>
                        </template>

                        <template slot="dtPrestacao" slot-scope="data">
                            <p class="text-left m-0">
                                {{ data.dtPrestacao ? $moment(data.dtPrestacao).format('DD/MM/YYYY') : '' }}
                            </p>
                        </template>

                        <template slot="nuTotalGasto" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.nuTotalGasto | currency }}
                            </p>
                        </template>

                        <template slot="nuTotalRendimentos" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.nuTotalRendimentos | currency }}
                            </p>
                        </template>

                        <template slot="nuReceitasDiversas" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.nuReceitasDiversas | currency }}
                            </p>
                        </template>
                        <template slot="valorContraPartidaFinanceira" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.valorContraPartidaFinanceira | currency }}
                            </p>
                        </template>
                        <template slot="valorContraPartidaEconomica" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.valorContraPartidaEconomica | currency }}
                            </p>
                        </template>
                        <template slot="situacao" slot-scope="data">
                            <app-status
                                :status="data.situacao.toUpperCase()"
                            ></app-status>
                        </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import CadPrestacaoMensal from '../cadastros/CadPrestacaoContasMensal'
import PrestacaoFinal from './ConvenioDadosDespesa'
import ConvenioDocumentos from './ConvenioDocumentos'

export default {
    props: {
        convenio: {
            type: Object,
            default: () => ({})
        },
        dataServicos: {
            type: Object
        },
        permiteCadastrarPrestacaoMensal: {
            type: Boolean,
            default: () => false
        },
        permiteExcluirJustificarPrestacaoMensal: {
            type: Boolean,
            default: () => false
        },
        permiteEnviarPrestacaoParaAnalise: {
            type: Boolean,
            default: () => false
        },
        temAcessoPrestacaoFinal: {
            type: Boolean,
            default: () => false
        },
        permiteCadastrarPrestacaoFinal: {
            type: Boolean,
            default: () => false
        },
        permiteExcluirPrestacaoFinal: {
            type: Boolean,
            default: () => false
        },
        permiteAtualizarPrestacaoFinal: {
            type: Boolean,
            default: () => false
        },
        permiteAcessarDocumentos: {
            type: Boolean,
            default: () => false
        },
        permiteCadastrarDocumentos: {
            type: Boolean,
            default: () => false
        },
        permiteExcluirDocumentos: {
            type: Boolean,
            default: () => false
        }
    },

    components: {
        CadPrestacaoMensal,
        PrestacaoFinal,
        ConvenioDocumentos
    },

    data() {
        return {
            listaPrestacoes: [],
            itensPorPagina: 5,
            campos: [
                {
                    key: 'idPrestacaoContasMensal',
                    label: 'Id',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dtCompetencia',
                    label: 'Competência',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dtPrestacao',
                    label: 'Data Prestação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuTotalGasto',
                    label: 'Total Despesas',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuTotalRendimentos',
                    label: 'Total Rendimentos',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuReceitasDiversas',
                    label: 'Receitas Diversas',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'valorContraPartidaEconomica',
                    label: 'Contrapartidas Econômicas',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'valorContraPartidaFinanceira',
                    label: 'Contrapartidas Financeiras',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ]
        }
    },

    methods: {
        carregarLista() {
            this.$store.dispatch('addRequest')
            this.dataServicos.ListarPrestacoesContas(
                this.$route.params.idConvenio
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.listaPrestacoes = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        excluir(id) {
            this.$store.dispatch('addRequest')
            this.dataServicos.ExcluirPrestacaoMensal(id).then((response) => {
                if (response) {
                    if (response.success) {
                        this.carregarLista()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarEnviar(id) {
            this.$swal({
                title: 'Enviar',
                html: 'Deseja Enviar a Prestação de Contas Mensal para análise?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.enviar(id)
                }
            })
            
        },

        confirmarExcluir(id) {
            this.$swal({
                title: 'Enviar',
                html: 'Deseja Excluir a Prestação Mensal?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir(id)
                }
            })
            
        },

        mostrarJustificativa(justificativa) {
            this.$swal({
                title: 'Justificativa',
                html: `<b>${justificativa}</b>`,
                icon: 'warning',
            })            
        },

        enviar(idPrestacaoMensal){
            this.$store.dispatch('addRequest')
            this.dataServicos.EnviarPrestacaoMensal(idPrestacaoMensal).then((response) => {
                if (response) {
                    if (response.success) {
                        this.carregarLista()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.carregarLista()
    }
}
</script>
